import React from 'react';
import Checkbox from '../form/FormsyCheckbox';
import Select from '../form/Select';

class DishEditDetails extends React.Component {
  render() {
    const {
      dish,
      availableCategories,
      availableDiets
    } = this.props;

    let availableFormats = [
      {id: "is_weekly", tag: "WEEKLY DISH"},
      {id: "is_special_occasion", tag: "SPECIAL OCCASION"},
      {id: "is_large_party", tag: "LARGE PARTY"}
    ]

    let categoryOptions = availableCategories.map(cat => ({ value: cat.id, label: cat.name}))
    return (
      <div className="dish-edit">
        <div className="row dish-edit__spacer dish-edit__spacer--delux">
          <div className="row__item row__item--third row__item--pad-right">
            <h2 className="dish-edit__label dish-edit__label--margin-bot">
              Category 1
            </h2>
            <Select
              name="category"
              placeholder="Category 1"
              value={dish.category ? dish.category.id : null}
              options={ categoryOptions }
              onChange={value => this.handleCategoryChange("category", value)}
            />
          </div>
          <div className="row__item row__item--third row__item--pad">
            <h2 className="dish-edit__label dish-edit__label--margin-bot">
              Category 2
            </h2>
            <Select
              name="category_2"
              placeholder="Category 2"
              value={dish.category_2 ? dish.category_2.id : null}
              options={ categoryOptions }
              onChange={value => this.handleCategoryChange("category_2", value)}
            />
          </div>
          <div className="row__item row__item--third row__item--pad">
            <h2 className="dish-edit__label dish-edit__label--margin-bot">
              Category 3
            </h2>
            <Select
              name="category_3"
              placeholder="Category 3"
              value={dish.category_3 ? dish.category_3.id : null}
              options={ categoryOptions }
              onChange={value => this.handleCategoryChange("category_3", value)}
            />
          </div>
        </div>
        <div className="row dish-edit__spacer dish-edit__spacer--delux">
          <div className="row__item row__item--full row__item--pad-right">
            <h2 className="dish-edit__label">Diet</h2>
            <div className="checkbox-row">
              {this.renderCheckboxes(
                availableDiets,
                dish.dietary_preference_tags,
                'dietary_preference_tags'
              )}
            </div>
          </div>
        </div>
        <div className="row dish-edit__spacer">
            <h2 className="dish-edit__label">
              Allergens{' '}
              <span className="dish-edit__label-inner">
                (Automatically pulled in from recipe ingredients)
              </span>
            </h2>
        </div>
        <div className="row">
          {this.renderAllergens(dish.allergens)}
        </div>

        <div className="row dish-edit__spacer">
          <div className="row__item row__item--full row__item--pad-right">
            <h2 className="dish-edit__label">
              Format
            </h2>
            <div className="checkbox-row">
              {this.renderFormats(
                availableFormats,
                dish.format || {},
                'format'
              )}
            </div>
          </div>
          <div className="row__item row__item--full row__item--pad-right">
          </div>
        </div>
      </div>
    );
  }

  renderAllergens(allergens = []) {
    const alrgns = allergens.map(allergen => allergen.tag).join(', ');
    return <p className="p">{alrgns}</p>;
  }

  renderFormats(items, formatsData, key) {
    let { updateDish } = this.props

    return items.map(item => (
      <div
        key={item.id}
        className="checkbox-row__item checkbox-row__item--third"
      >
        <Checkbox
          name={item.tag}
          className="checkbox--large checkbox--large-blue checkbox--flex form__row-item--third"
          placeholder={item.tag}
          checked={(formatsData && formatsData[item.id]) || false}
          onChange={function () { 
            let data = Object.assign({}, formatsData, { [item.id]: !formatsData[item.id]})
            updateDish({[key]: data })  
          }}
        />
      </div>
    ));
  }

  renderCheckboxes(items, selectedItems, key) {
    const { isChecked, toggleChecked } = this;
    if (!items || items.length < 1) return;
    return items.map(item => (
      <div
        key={item.id}
        className="checkbox-row__item checkbox-row__item--third"
      >
        <Checkbox
          name={item.tag}
          className="checkbox--large checkbox--large-blue checkbox--flex form__row-item--third"
          placeholder={item.tag}
          checked={isChecked(item, selectedItems)}
          onChange={e => toggleChecked(item, selectedItems, key)}
        />
      </div>
    ));
  }

  handleCategoryChange = (fieldName, value) => {
    let choosenCat = value ? this.props.availableCategories.find(cat => cat.id === value.value) : null
    const dish = { [fieldName]: choosenCat}
    this.props.updateDish(dish);
  };

  isChecked = (value, selectedItems = []) => {
    return selectedItems.findIndex(val => val.id === value.id) >= 0;
  };

  toggleChecked = (value, selectedItems = [], key) => {
    if (this.isChecked(value, selectedItems)) {
      // delete
      const index = selectedItems.findIndex(val => val.id === value.id);
      selectedItems = [
        ...selectedItems.slice(0, index),
        ...selectedItems.slice(index + 1, selectedItems.length)
      ];
    } else selectedItems.push(value);

    this.props.updateDish({ [key]: selectedItems });
  };
}

export default DishEditDetails;



// WEBPACK FOOTER //
// ./src/components/dish/DishEditDetails.js